import showCtls from './showCtls/index';
import busCtls from './busCtls/index';
import mainPageBaseCtls from '../../main-page-base/ctls/allCtls';
import pageFormCtls from '../../main-page-form/ctls/allCtls';
import extendCtls from '../../main-page-extend/allCtls';

export default {
  ...extendCtls,
  ...pageFormCtls,
  ...mainPageBaseCtls,
  ...showCtls,
  ...busCtls,
}
